import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 7l-10 10","key":"svg-0"}],["path",{"d":"M16 17l-9 0l0 -9","key":"svg-1"}]]

const IconArrowDownLeft = createReactComponent('outline', 'arrow-down-left', 'ArrowDownLeft', __iconNode);

export default IconArrowDownLeft;